// Hand-written companion to the codegen output in `./accounts.ts`.
//
// `rtk-openapi.recalc.config.cjs` only lists `accounts.ts` (and its sibling
// endpoint files) as `outputFiles`, so re-running the recalc OpenAPI codegen
// never touches this file - customizations here survive regeneration.
//
// `POST /Accounts` replies `201 Created` with an empty body; the new
// account's id is only exposed via the `Location` response header. The
// codegen can't express header-derived data (its declared response type is a
// bare `object`), so we patch `accountsPostAsyncBynewAccount`'s
// `transformResponse` here at runtime - mirroring what the old hand-written
// `src/api/recalc/endpoints/accountsApiSlice.jsx` `createAccount` mutation
// used to do.
import { recalcOpenApi } from './accounts';

export * from './accounts';

/** Runtime shape returned by the patched `accountsPostAsyncBynewAccount`
 * mutation. The codegen's own `AccountsPostAsyncBynewAccountApiResponse`
 * type (`object`) can't express this, so callers need to cast, e.g.
 * `(await createAccount(...).unwrap()) as AccountsPostAsyncBynewAccountEnhancedResponse`. */
export type AccountsPostAsyncBynewAccountEnhancedResponse = {
  data: object;
  /** New account id parsed from the `Location` header, e.g. "42". */
  accountId: string | null;
};

const enhancedRecalcAccountsApi = recalcOpenApi.enhanceEndpoints({
  endpoints: {
    accountsPostAsyncBynewAccount: {
      transformResponse: (response, meta) => {
        const location = meta?.response?.headers.get('Location') ?? null;
        const accountId = location ? location.split('/').pop() : null;
        return { data: response, accountId };
      },
    },
  },
});

export const { useAccountsPostAsyncBynewAccountMutation } =
  enhancedRecalcAccountsApi;
